interface IconProps {
  className?: string;
}

const AttachmentIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M16.126 6.5v10.542a3.666 3.666 0 0 1-3.666 3.666 3.666 3.666 0 0 1-3.667-3.666V5.583a2.292 2.292 0 0 1 4.583 0v9.625a.92.92 0 0 1-.916.917.92.92 0 0 1-.917-.917V6.5h-1.375v8.708a2.292 2.292 0 0 0 4.583 0V5.583a3.666 3.666 0 0 0-3.666-3.666 3.666 3.666 0 0 0-3.667 3.666v11.459a5.04 5.04 0 0 0 5.042 5.041 5.04 5.04 0 0 0 5.041-5.041V6.5z"
      ></path>
    </svg>
  );
};

export default AttachmentIcon;
